const moment = require("moment");

module.exports = {
  formatDate: (date, format = "D MMM YYYY hh:mm A") => {
    return moment(date).format(format);
  },

  getTimeAgo: (timestamp) => {
    const now = new Date();
    const updated = new Date(timestamp);
    const diff = Math.floor((now - updated) / 1000); // in seconds

    if (diff < 5) return "just now";
    if (diff < 60) return `${diff} second${diff > 1 ? "s" : ""} ago`;

    const minutes = Math.floor(diff / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

    const days = Math.floor(hours / 24);

    if (days > 2) {
      return this.formatDate(timestamp);
    }

    return `${days} day${days > 1 ? "s" : ""} ago`;
  },

  getInitials: (name) => {
    return (
      name
        ?.split(" ")
        .map((w) => w[0])
        .join("")
        .toUpperCase()
        .slice(0, 2) || "NA"
    );
  },

  getOrderStatusBadge(status) {
    switch (status) {
      case "placed":
        return "bg-secondary";
      case "processing":
        return "bg-info text-white";
      case "shipped":
        return "bg-warning text-dark";
      case "delivered":
        return "bg-success";
      case "cancelled":
        return "bg-danger";
      default:
        return "bg-light text-dark";
    }
  },

  getPaymentStatusBadge(status) {
    switch (status) {
      case "pending":
        return "bg-warning text-dark";
      case "authorized":
        return "bg-info text-white";
      case "paid":
        return "bg-success";
      case "failed":
        return "bg-danger";
      case "cancelled":
        return "bg-secondary";
      default:
        return "bg-light text-dark";
    }
  },

  getBadgeColor(status) {
    switch (status) {
      case "scheduled":
        return "info";
      case "active":
        return "success";
      case "expired":
        return "secondary";
      case "cancelled":
        return "danger";
      default:
        return "secondary";
    }
  },
};
